// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1tKm0","header":"Messages_header__3iIrQ"};